<template>
    <div class="card ">
        <div class="card-body">
            <div class="overview-title pe-2 ps-2">Overview</div>
            <div class=" d-flex justify-content-between align-items-center pe-2 ps-2 parent-container">
                <div class="overview-key-metrics">Key metrics</div>
                <button class="btn btn-primary btn-datepicker" @click="toggleDateRangePicker">
                {{ dateRangeLabel }} <i class="fa fa-chevron-down"></i>
                </button>           
            
            </div>
            <div class="p-2 mt-1">
                <div class=" d-flex justify-content-between">
                    <div class="face-value">Face value</div>
                    <div>
                        <div v-if="isPositive(overviewStore.overviewInfo.face_value_diff_percent)">
                            <img class="value-icon" src="@/assets/images/icon/up.png"  />
                        </div>
                        <div v-else>
                            <img class="value-icon" src="@/assets/images/icon/down.png" />
                        </div>
                    </div>
                </div>
                <div class=" d-flex justify-content-between">
                    <div class="left-value">{{ formatCurrency(overviewStore.overviewInfo.face_value) }}</div>
                    <div class="right-value">{{ overviewStore.overviewInfo.face_value_diff_percent}}%</div>
                </div>
                <hr>
                <div class=" d-flex justify-content-between">
                    <div class="face-value">Total commission</div>
                    <div>
                        <div v-if="isPositive(overviewStore.overviewInfo.total_commission_diff_percent)">
                            <img class="value-icon" src="@/assets/images/icon/up.png"  />
                        </div>
                        <div v-else>
                            <img class="value-icon" src="@/assets/images/icon/down.png" />
                        </div>
                    </div>
                </div>
                <div class=" d-flex justify-content-between">
                    <div class="left-value">{{ formatCurrency(overviewStore.overviewInfo.total_commission) }}</div>
                    <div class="right-value">{{ overviewStore.overviewInfo.total_commission_diff_percent }}%</div>
                </div>
                <hr>
                <div class=" d-flex justify-content-between">
                    <div class="face-value">Transactions</div>
                    <div class="img-icon">
                        <div v-if="isPositive(overviewStore.overviewInfo.transaction_count_diff_percent)">
                            <img class="value-icon" src="@/assets/images/icon/up.png"  />
                        </div>
                        <div v-else>
                            <img class="value-icon" src="@/assets/images/icon/down.png" />
                        </div>                 
                    </div>
                </div>
                <div class=" d-flex justify-content-between">
                    <div class="left-value">{{ overviewStore.overviewInfo.transaction_count }}</div>
                    <div class="right-value">{{ overviewStore.overviewInfo.transaction_count_diff_percent }}%</div>
                </div>
                <hr>
            </div>
            <div class="mt-5 mb-5">&nbsp;</div>
        </div>
    </div>

    <div class="your-account-container">
        <div  class="frame-account pe-2 ps-2">
            <div class="account-title">Your account</div>
            <div>
                <img class="account-icon" src="@/assets/images/driver/account.png" />
            </div>
        </div>
        <div class="pe-2 ps-2">
            <div class="account-balance">Account balance</div>
            <div class="account-value">{{ formatCurrency(overviewStore.overviewInfo.account_balance) }}</div>
            <div class="pending-text mt-1">Money in your account pending withdrawal</div>
        </div>
    </div>

    <DateRangePicker
                v-if="isPickerVisible"
                @update-range="updateDateRange"
                @close="isPickerVisible = false"
     />
</template>

<script setup>
import { ref,onMounted } from 'vue';
import { useOverviewStore } from '@/store/driver/overview';
import DateRangePicker from './dateRangePicker.vue';

// 使用 Pinia store
const overviewStore = useOverviewStore();

const isPickerVisible = ref(false);
const dateRangeLabel = ref('This month');

const predefinedRanges = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This week', value: 'this_week' },
  { label: 'Last week', value: 'last_week' },
  { label: 'This month', value: 'this_month' },
  { label: 'Last month', value: 'last_month' },
  { label: 'This year', value: 'this_year' },
  { label: 'Last year', value: 'last_year' },
  { label: 'Custom', value: 'custom' },
];

// 切換日期範圍選擇器的顯示狀態
const toggleDateRangePicker = () => {
  isPickerVisible.value = !isPickerVisible.value;
};

// 更新選擇的日期範圍並叫用 API
const updateDateRange = async (range) => {
  if (range.type === 'custom') {
    const start = formatDate(range.start);
    const end = formatDate(range.end);
    dateRangeLabel.value = `${start} - ${end}`;
    await overviewStore.fetchOverviewInfo('custom', start, end);
  } else {
    const selectedRange = predefinedRanges.find(r => r.value === range.type);
    dateRangeLabel.value = selectedRange.label;
    await overviewStore.fetchOverviewInfo(range.type);
  }
};

// 格式化日期
const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

// 判斷值是否為正數
const isPositive = (value) => value > 0;

const formatCurrency = (value) => {
    const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};


onMounted(() => {
  overviewStore.fetchOverviewInfo('this_month');
});
</script>

<style scoped>
.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 75%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: hidden;
    overflow-x: hidden; /* 防止左右滑動 */
}

.parent-container {
  position: relative;
}

.overview-title{
    width: 169px;
    height: 30px;
    /* Portal/Portal – H4 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 10px;
    margin-top: 5px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.overview-key-metrics{
    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.btn-datepicker{
    border-radius: 30px;
    font-size: 16px;
}


.face-value{

/* Portal/Portal – H7 */
font-family: 'Euclid Square';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 20px;

/* Navy */
color: #051C2C;


/* Inside auto layout */
flex: none;
order: 0;
flex-grow: 0;

}

.left-value{
/* Portal/Portal – H2 bold */
font-family: 'Euclid Square';
font-style: normal;
font-weight: 600;
font-size: 36px;
line-height: 46px;
display: flex;
align-items: center;

/* Navy */
color: #051C2C;


/* Inside auto layout */
flex: none;
order: 1;
align-self: stretch;
flex-grow: 0;

}

.right-value{
    margin: 20 auto;
    margin-top: 20px;
    /* Portal/Portal – H7 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-align: right;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
}

.img-icon {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
}



.value-icon{
    /* icon */
    width: 24px;
    height: 24px;

}


/* Your account section 固定在底部 */
.your-account-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 23vh; /* 佔據 20% 的視窗高度 */
  background-color: #f4f4f8;
  padding: 10px;
  z-index:1;
  border-radius: 20px 20px 0px 0px;
}

.account-title {

    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.calendar-icon {
  width: 24px;
  height: 24px;
}

.account-balance {
    /* Account balance */

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.account-value{
    /* Portal/Portal – H2 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 46px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;

}

.pending-text {

    /* Portal/Portal – body extra small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    /* identical to box height */

    /* Navy */
    color: #051C2C;

    opacity: 0.5;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;

}

.account-icon{
    margin: 0 auto;


    width: 48px;
    height: 48px;


    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;

}

.frame-account{
    display: flex;
    justify-content: space-between; /* 讓內容居左右兩端 */
    width: auto; /* 確保寬度覆蓋整個父容器 */
}

</style>

